import { useContext } from 'react'

import { FolderTreeContext } from '../../providers/folder-tree-provider'

// Derives what the user can reach from the folder tree; values are unset until it loads
const useFolderTree = () => {
  const { folderTree, error } = useContext(FolderTreeContext)

  const folderCount = folderTree ? Object.keys(folderTree.tree).length : 0

  return {
    hasMultipleFolders: folderCount > 1,
    singleFolderId: folderTree && folderCount === 1 ? folderTree.roots[0] : null,
    folderTree,
    hasFolderTreeError: error,
  }
}

export default useFolderTree
